import _ from 'lodash';

const initForm = function () {
  return {
    userNote: '',
    noticeMobile: '',
    is_agree_rule: false,
    is_agree_box_rule: false,
    buyNowInfo: null,
    preBuyInfo: null,
  };
};

const state = initForm();

const mutations = {
  changeUserNote(state, value) {
    state.userNote = value;
  },
  changeMobile(state, value) {
    state.noticeMobile = value;
  },
  changePreRule(state, value) {
    state.is_agree_rule = value;
  },
  changeBoxRule(state, value) {
    state.is_agree_box_rule = value;
  },
  changeBuyNowInfo(state, value) {
    state.buyNowInfo = value;
  },
  changePreBuyInfo(state, value) {
    state.preBuyInfo = value;
  },
  clearNoteData(state) {
    _.assign(state, initForm());
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
